import $ from 'jquery';
import uniqueId from 'lodash/uniqueId';
import groupBy from 'lodash/groupBy';
import A11yUtils from '@core/base/scripts/utils/a11y-utils';
import SimpleBar from 'simplebar';
import Utils from '@core/base/scripts/utils/utils';

export default class PredictiveSearch {

  constructor(id) {
    this.LANG=document.documentElement.lang;
    this.CLASSES = {
      list: 'predictive-search__list',
      listContainer: 'predictive-search__list-container',
      listFooter: 'predictive-search__list--footer',
      listItem: 'predictive-search__list-item',
      listItemSelected: 'predictive-search__list-item--selected',
      reset: 'predictive-search__reset'
    }
    this.BTN_CLASSES = {
      desktop: 'base-button button--secondary btn-display-all'
    };
    this.PARAM = '&search_api_language';
    this.MINCHAR_NUMBER = 1;
    this.drupalSettings = {
      language: 'fr',
      path: {
        currentLanguage: 'fr'
      }
    };
    //
    this.id = id;
    this.fakeAjaxUrl = '';
    this.ajaxUrl = `/${this.LANG}/search/autocomplete`;
    this.$container = null;
    this.$searchReset = null;
    this.$input = null;
    this.inputVal = null;
    this.$results = null;
    this.results = [];
    this.lastResults = [];
    this.$live = null;
    this.results = null;
    this.nextItemCount = -1;
    this.resultsClosed = true;
  }

  init() {
    this.$container = $('#' + this.id);
    this.$searchReset = $('.' + this.CLASSES.reset, this.$container);
    this.$input = this.$container.find('input[type="text"]');
    this.inputVal = "";
    this.$results = this.$container.find('.' + this.CLASSES.listContainer);
    this.$live = this.$container.find('[aria-live]');
    //
    this.eventListeners();
  }


  eventListeners() {
    // close results if click outside $input and $results
    document.addEventListener('click', e => {
      if (A11yUtils.senseClickOutside($(e.target), this.$container)) {
        this.closeResults();
      }
    });
    //if focus is on input reset the next item count for arrowing
    this.$input.on('focus', e => {
      this.nextItemCount = -1;
    });
    //if keyup on input lnauch the ajax request
    this.$input.on('keyup', e => {
      e.preventDefault();
      this.toggleResetButton();
      var kc = e.keyCode;
      if (kc === A11yUtils.keyboard.up || kc === A11yUtils.keyboard.down || kc === A11yUtils.keyboard.tab || kc === A11yUtils.keyboard.enter || kc === A11yUtils.keyboard.esc) {
        return false;
      }
      this.autocomplete();
      e.stopImmediatePropagation();
      return false;
    });
    //key down event for arrowing and tab
    this.$container.on('keydown', e => {
      this.toggleResetButton();
      var kc = e.keyCode;
      if (kc === A11yUtils.keyboard.tab) {
        this.closeResults();
      }
      if (kc === A11yUtils.keyboard.esc) {
        e.preventDefault();
        this.$input.focus();
        this.closeResults();
        e.stopImmediatePropagation();
        return false;
      }
      if (kc === A11yUtils.keyboard.up || kc === A11yUtils.keyboard.down) {
        e.preventDefault();
        this.arrowing(kc);
        e.stopImmediatePropagation();
        return false;
      }
      return true;
    });
    //clear the input value
    this.$searchReset.on('click', () => {
      this.inputVal = '';
      this.$input.val(this.inputVal);
      this.emptySearch();
    });
  }

  autocomplete() {
    //if input value didn't change, return
    if (this.$input.val() === this.inputVal) {
      return;
    }
    // save new input value
    this.inputVal = this.$input.val();
    // get and save autocomplete results
    if (this.inputVal.length > this.MINCHAR_NUMBER) {
      this.launchAjaxRequest();
    } else {
      A11yUtils.announcements(this.$live, this.$container.data('maxchar'));
      this.closeResults();
    }
  }


  launchAjaxRequest(callback) {
    A11yUtils.announcements(this.$live, this.$container.data('isloading'));

    this.$container.addClass('is-loading');

    $.ajax({
        url: this.getAjaxUrl(),
        type: "GET",
        dataType: "json"
      })
      .done((data) => {
        this.$container.removeClass('is-loading');
        this.results = data;
        // render Html list
        if (this.results && this.results.length === 0) {
          this.closeResults();
        } else if (this.results && this.results.length !== this.lastResults.length) {

          // const Results = groupBy(data, 'category');
          // this.results = Results;
          this.renderHtmlList(this.results);
          this.simpleBar = new SimpleBar(document.querySelectorAll('.predictive-search__list-wrapper')[0], {
            autoHide: false
          });
        }
        this.toggleResetButton();
        // aria-live results
        this.resultsAnnouncement();
        //
        if (callback) callback();
      })
      .fail(function (data) {});
  }

  renderHtmlList(results) {
    //
    this.$results.empty();
    this.resultsClosed = false;
    //
    this.buildList(results.items);

    const keySearched = $('.predictive-search-wrapper input[type="text"]',this.$container).val();

    //add "display all results" button
    const href = `/${this.LANG}/search?search_api_fulltext=${keySearched}${this.PARAM}[${this.LANG}]=${this.LANG}`;
    const $btnDesktop = `<a href="${href}" class="${this.BTN_CLASSES.desktop}">${this.$container.data('allresults')}</a>`;
    const listMarkup = `
    <ul class="${this.CLASSES.list} ${this.CLASSES.listFooter}">
      <li class="${this.CLASSES.listItem} ${this.CLASSES.listItemSelected}" id="${uniqueId('listitemresult_')}">
        ${$btnDesktop}
      </li>
    </ul>
    `;

    this.$results.append($(listMarkup));

    //put all <a> out of tabulation native order
    this.$results.find('a').attr('tabindex', '-1');

    //display list
    $('.' + this.CLASSES.listContainer).addClass(this.CLASSES.listContainer + '--show');
    this.$input.attr('aria-expanded', 'true');
    //
    //reset next count for arrowing
    this.nextItemCount = -1;
  }

  buildList(items) {
    const $listWrapper = $('<div class="predictive-search__list-wrapper"></div>');

    let listLabel = uniqueId('listtitleresult_');
    let $ul = $(`<ul id="${uniqueId('listresult_')}" aria-labelledby="${listLabel}" class="${this.CLASSES.list}"></ul>`);

    $.each(items, (key, item) => {
      const $link =  $(`<a href="${item.href}" target="${item.target}">${item.title}</a>`);
      const txt = $link.text();
      $link.attr('title', txt);
      $link.html(this.detectAndReplaceInString(txt, this.inputVal));

      const $item = $(`<li class="${this.CLASSES.listItem+' '+this.CLASSES.listItemSelected}" id="${uniqueId('listitemresult_')}"></li>`);
      $item.append($link);
      $ul.append($item);
    });

    $listWrapper.append($ul);
    this.$results.append($listWrapper);
  }

  getAjaxUrl() {
    let url = null;
    if (this.fakeAjaxUrl !== '') {
      url = this.fakeAjaxUrl;
    } else {
      url = this.ajaxUrl + '?search_api_fulltext=' + this.inputVal
    }
    return url;
  }


  arrowing(kc) {
    const $listsItems = this.$container.find('.' + this.CLASSES.listItem);
    // find the next list item to be arrowed to
    if (kc === A11yUtils.keyboard.down) {
      if (this.nextItemCount >= $listsItems.length - 1) {
        this.nextItemCount = -1;
      }
      this.nextItemCount++;
      this.selectItem($listsItems.eq(this.nextItemCount));
    }
    if (kc === A11yUtils.keyboard.up) {
      if (this.nextItemCount === 0) {
        this.$input.focus();
      } else {
        this.nextItemCount--;
        this.selectItem($listsItems.eq(this.nextItemCount));
      }
    }
  }

  selectItem($selectedItem) {
    // don't mark anything on the results list if we're back at the input field
    if ($selectedItem.length === 0) {
      return;
    }
    $(this.CLASSES.listItemSelected).removeClass(this.CLASSES.listItemSelected);
    $selectedItem.addClass(this.CLASSES.listItemSelected).find('a').focus();
  }

  resultsAnnouncement() {
    let textToRead;
    let resultsStr = "";
    if (this.results) {
      $.each(this.results, function (key, datas) {
        resultsStr += key + " (" + datas.length + ") ";
      });
      textToRead = this.$container.data('results') + " " + resultsStr;
    } else {
      textToRead = this.$container.data('noresults');
    }
    A11yUtils.announcements(this.$live, textToRead);
  }


  closeResults() {
    this.resultsClosed = true;
    $('.' + this.CLASSES.listContainer).removeClass(this.CLASSES.listContainer + '--show');
    this.$input.attr('aria-expanded', 'false');
    this.$results.empty();
  }

  toggleResetButton() {
    const hasValue=this.$input.val() !== '';
    $('.predictive-search__reset-container').toggleClass('predictive-search__reset-container--show', hasValue);
    this.$searchReset.toggleClass(this.CLASSES.reset + '--show', hasValue);
    this.$searchReset.attr('aria-hidden', this.$input.val() === '');
    //force every modal to update its focusables elements
    setTimeout(() => {
      const event = document.createEvent('HTMLEvents');
      event.initEvent('updateModalFocusables', true, false);
      document.dispatchEvent(event);
    }, 300);
  }

  emptySearch() {
    this.$input.val('');
    this.$input.focus();
    this.toggleResetButton();
    this.closeResults();
  }

  detectAndReplaceInString(sentence, wordToSearch) {
    const length = wordToSearch.length;

    var text = sentence, // ***
      textL = text.toLowerCase(),
      index = textL.indexOf(wordToSearch.toLowerCase()); // ***

    if (index !== -1) {
      return `${text.substr(0, index)}<span class="hightlighted">${text.substr(index, length)}</span>${text.substr(index + length)}`;
    } else {
      return sentence;
    }
  }

}
